export { default } from './CategoryTabs';
